import {
  Card,
  CardBody,
} from "@material-tailwind/react";

import Chart from "react-apexcharts";
import PropTypes from "prop-types";
import Loading from "../layout/loading";

export function CardChart({ data, isLoading, height }) {

  // LMA Theme colors
  const lmaColors = {
    dark: '#282D32',
    gold: '#B09879',
    gray: '#58585b',
    light: '#f5f5f5',
  };

  const chartOptions =  {
    chart: {
      toolbar: {
        show: true,
      },
      fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
      foreColor: lmaColors.gray,
      events: {
        mounted: () => {
          // Wait for DOM to render menu
          setTimeout(() => {
            document.querySelectorAll('.apexcharts-menu-item').forEach((item) => {
              if (item.textContent.includes('Download CSV')) {
                item.style.display = 'none';
              }
            });
          }, 500);
        },
      },
    },
    colors: [lmaColors.gold, lmaColors.dark, lmaColors.gray],
    stroke: {
      width: 2,
      curve: 'smooth',
    },
    markers: {
      size: 0,
    },
    title: {
      text: data.title,
      style: {
        fontSize: '14px',
        fontWeight: 500,
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        color: lmaColors.dark,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
      labels: {
        colors: lmaColors.gray,
      },
    },
    grid: {
      borderColor: '#e8e8e8',
      strokeDashArray: 4,
    },
    xaxis: {
      type: "datetime",
      labels: {
        format: "dd MMM yy",
        style: {
          colors: lmaColors.gray,
          fontSize: '12px',
          fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        },
      },
      tickAmount: 3
    },
    yaxis: {
      type: 'numeric',
      tickAmount: 3,
      labels: {
        formatter: function (value) {
          if (value) return value.toFixed(0);
        },
        style: {
          colors: lmaColors.gray,
          fontSize: '12px',
          fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        },
      }
    },
    tooltip: {
      theme: 'light',
    },
  };


  return (
    <Card className="h-full">
    {/*<CardHeader
      floated={false}
      shadow={false}
      color="transparent"
      className="m-0 p-6"
    >
       <Typography variant="h6" color="blue-gray" className="mb-2">
        {data.title}
      </Typography> 
    </CardHeader>*/}
    <CardBody className="pt-0 h-full">
      {isLoading && <Loading key={`loading-card-chart`}></Loading>}
      {!isLoading &&
        <Chart
          options={chartOptions}
          series={data.series}
          type="line"
          height={height} />}
    </CardBody>
  </Card>
      
  );
}

CardChart.defaultProps = {
  color: "blue",
  footer: null,
};

CardChart.propTypes = {
  color: PropTypes.oneOf([
    "white",
    "blue-gray",
    "gray",
    "brown",
    "deep-orange",
    "orange",
    "amber",
    "yellow",
    "lime",
    "light-green",
    "green",
    "teal",
    "cyan",
    "light-blue",
    "blue",
    "indigo",
    "deep-purple",
    "purple",
    "pink",
    "red",
  ]),
  footer: PropTypes.node,
};

CardChart.displayName = "/src/widgets/cards/card-chart.jsx";

export default CardChart;
